import React from "react";

const MetricCard = ({ title, value, color, categoryName, onClick }) => {
  return (
    <div 
      className="metric-card hover:bg-gray-100" 
      onClick={onClick} 
      style={{ cursor: onClick ? 'pointer' : 'default' }}
    >
      {categoryName && (
        <div
          className="inline-block px-2 py-1 mb-2 text-xs font-sm rounded-full shadow-sm"
          style={{
            backgroundColor: "rgba(211,47,47,0.1)",
            color: "#AD0101",
            border: "1px solid #AD0101",
          }}
        >
          {categoryName}
        </div>
      )}
      <h3 className="metric-title">{title}</h3>
      <p className="metric-value" style={{ color: color }}>
        {value}
      </p>
    </div>
  );
};

export default MetricCard;